import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default (
  <Route key="/consumer/accessibility-statement" element={<DefaultConsumerLayout />}>
    <Route path="consumer/accessibility-statement" element={<AsyncPage />} />
  </Route>
);
